import React, {ReactElement, ReactNode, useEffect} from 'react';
import {cx} from '@emotion/css';
import {useFlags} from 'launchdarkly-react-client-sdk';

import Navigation from '@fo/components/NavigationWrapper/NavigationWrapperWithQuery';
import {logPageVisit} from '@fo/shared-analytics/tracking/segment';
import {ETheme} from '@fo/root/Templates/TideTemplates/shared/enums/themes';
import FooterV2 from '@fo/components/tideComponents/FooterV2';

import styles from './GeneralLayout.styles';

interface Props {
  children: ReactNode;
  className?: string;
  hideNavigationCtaButton?: boolean;
  hideTideBranding?: boolean;
  theme?: ETheme;
  isSkipQuoteFormAndRedirectToTide?: boolean;
}

function GeneralLayout({
  children,
  className,
  hideNavigationCtaButton,
  hideTideBranding,
  theme,
  isSkipQuoteFormAndRedirectToTide,
}: Props): ReactElement {
  const flags = useFlags();

  useEffect(() => {
    logPageVisit();
  }, []);

  useEffect(() => {
    if (flags && window?.fundingOptions) {
      const pcsFlagKeys = Object.keys(flags).filter((key) => new RegExp(/^(pcsReact)/).test(key));
      window.fundingOptions.flags = pcsFlagKeys.reduce((acc, key) => ({...acc, [key]: flags[key]}), {});
    }
  }, [flags]);

  return (
    <div className={cx(styles.container, className)}>
      <Navigation
        hideCtaButton={hideNavigationCtaButton}
        hideTideBranding={hideTideBranding}
        theme={theme}
        isSkipQuoteFormAndRedirectToTide={isSkipQuoteFormAndRedirectToTide}
      />
      <div className={cx(styles.inner)}>{children}</div>
      <FooterV2 />
    </div>
  );
}

export default GeneralLayout;
